import React from "react";
import slider1 from "../images/rosalinchilddevelopment-hero-1.jpg";
import slider2 from "../images/rosalinchilddevelopment-hero-2.jpg";
import slider4 from "../images/rosalin-award.jpg";
import slidermin1 from "../images/rosalinchilddevelopment-mobile-hero-1.jpg";
import slidermin2 from "../images/rosalinchilddevelopment-mobile-hero-2.jpg";
import { Button } from "react-bootstrap";

// webp variants served from public/ for stable URLs used in <link rel="preload"> in index.html
const slide1WebpMobile = "/rosalinchilddevelopment-mobile-hero-1.webp";
const slide1WebpDesktop = "/rosalinchilddevelopment-hero-1.webp";

const MainBanner = ({ width }) => {
  const isMobile = width <= 768;
  const slide1Img = isMobile ? slidermin1 : slider1;
  const slide1Webp = isMobile ? slide1WebpMobile : slide1WebpDesktop;
  const slide1W = isMobile ? 1536 : 2732;
  const slide1H = isMobile ? 866 : 1536;

  return (
    <div className="mainBanner">
      {/* Slide 1 — LCP image, always eager */}
      <div className="mbBgIma">
        <picture>
          <source srcSet={slide1Webp} type="image/webp" />
          <img
            className="mbBgImaImg"
            src={slide1Img}
            alt=""
            aria-hidden="true"
            width={slide1W}
            height={slide1H}
            loading="eager"
            fetchpriority="high"
            decoding="async"
          />
        </picture>
        <div className="mbiCon">
          <h1>Every Child Deserves the Right Support to Thrive</h1>
          <div className="mbiBtns">
            <Button variant="primary" size="lg" href="/book-appointment">
              Book an Assessment
            </Button>
            <Button variant="outline-light" size="lg" href="/contact-us" className="ms-2">
              Talk to Our Experts
            </Button>
          </div>
        </div>
      </div>

      {/* Slides 2 & 3 — desktop only, lazy loaded */}
      {!isMobile && (
        <>
          <div className="mbBgIma">
            <img
              className="mbBgImaImg"
              src={slider2}
              alt=""
              aria-hidden="true"
              width="2732"
              height="1536"
              loading="lazy"
              decoding="async"
            />
            <div className="mbiCon">
              <h2>Compassionate, Evidence-Informed Therapy for Every Child</h2>
              <p>Personalised support in a child-friendly environment.</p>
            </div>
          </div>
          <div className="mbBgIma">
            <img
              className="mbBgImaImg"
              src={slider4}
              alt=""
              aria-hidden="true"
              width="450"
              height="245"
              loading="lazy"
              decoding="async"
            />
            <div className="mbiCon">
              <h2>Because Every Small Step Matters</h2>
              <p>Celebrating every milestone in your child's journey.</p>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default MainBanner;
